export default {
  label: {
    exportPng: 'Export PNG',
  },
};
